import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function Modal({
  title,
  children,
  onClose
}: {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}) {
  return <AnimatePresence data-id="element-66">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50" onClick={onClose} data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-68">
          <div className="sticky top-0 bg-white border-b border-brand-beige p-6 flex items-center justify-between rounded-t-2xl" data-id="element-69">
            <h2 className="text-2xl font-serif font-bold text-brand-brown" data-id="element-70">
              {title}
            </h2>
            <button onClick={onClose} className="p-2 rounded-full hover:bg-brand-beige transition-colors" aria-label="Cerrar" data-id="element-71">
              <XIcon className="w-5 h-5 text-brand-brown" data-id="element-72" />
            </button>
          </div>
          <div className="p-6 md:p-8 text-brand-dark text-base leading-relaxed space-y-4" data-id="element-73">
            {children}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}
function PrivacyContent() {
  return <>
      <p data-id="element-74">
        <strong data-id="element-75">Última actualización:</strong> Abril 2026
      </p>
      <p data-id="element-76">
        En Rodillas Sin Dolor, respetamos su privacidad y nos comprometemos a
        proteger su información personal.
      </p>
      <h3 className="text-xl font-serif font-bold text-brand-brown pt-2" data-id="element-77">
        1. Información que Recopilamos
      </h3>
      <p data-id="element-78">
        Recopilamos únicamente la información que usted nos proporciona
        voluntariamente al descargar nuestra guía, como su nombre y dirección de
        correo electrónico.
      </p>
      <h3 className="text-xl font-serif font-bold text-brand-brown pt-2" data-id="element-79">
        2. Uso de la Información
      </h3>
      <p data-id="element-80">Utilizamos su información exclusivamente para:</p>
      <ul className="list-disc pl-6 space-y-2" data-id="element-81">
        <li data-id="element-82">Enviarle la guía solicitada.</li>
        <li data-id="element-83">
          Compartir contenido educativo relacionado con el bienestar articular.
        </li>
      </ul>
      <h3 className="text-xl font-serif font-bold text-brand-brown pt-2" data-id="element-84">
        3. Protección de Datos
      </h3>
      <p data-id="element-85">
        No vendemos, alquilamos ni compartimos su información personal con
        terceros. Implementamos medidas de seguridad razonables para proteger
        sus datos.
      </p>
      <h3 className="text-xl font-serif font-bold text-brand-brown pt-2" data-id="element-86">
        4. Sus Derechos
      </h3>
      <p data-id="element-87">
        Usted puede solicitar la eliminación de sus datos o darse de baja de
        nuestras comunicaciones en cualquier momento haciendo clic en el enlace
        de cancelación incluido en cada correo.
      </p>
      <h3 className="text-xl font-serif font-bold text-brand-brown pt-2" data-id="element-88">
        5. Cookies
      </h3>
      <p data-id="element-89">
        Este sitio puede utilizar cookies básicas para mejorar su experiencia de
        navegación. No utilizamos cookies de seguimiento publicitario.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p data-id="element-90">
        <strong data-id="element-91">Última actualización:</strong> Abril 2026
      </p>
      <p data-id="element-92">
        Al acceder a este sitio web y descargar nuestros materiales, usted
        acepta los siguientes términos y condiciones.
      </p>
      <h3 className="text-xl font-serif font-bold text-brand-brown pt-2" data-id="element-93">
        1. Naturaleza del Contenido
      </h3>
      <p data-id="element-94">
        Todo el contenido proporcionado en la guía "Rodillas Sin Dolor" es de
        carácter educativo e informativo. No constituye consejo médico
        profesional, diagnóstico ni tratamiento.
      </p>
      <h3 className="text-xl font-serif font-bold text-brand-brown pt-2" data-id="element-95">
        2. Consulta Médica
      </h3>
      <p data-id="element-96">
        Siempre consulte con un profesional de la salud calificado antes de
        iniciar cualquier protocolo de salud, ejercicio o cambio en su
        alimentación, especialmente si tiene condiciones médicas preexistentes.
      </p>
      <h3 className="text-xl font-serif font-bold text-brand-brown pt-2" data-id="element-97">
        3. Propiedad Intelectual
      </h3>
      <p data-id="element-98">
        Todo el contenido, incluyendo textos, imágenes y diseños, es propiedad
        de Rodillas Sin Dolor. Queda prohibida su reproducción, distribución o
        modificación sin autorización previa por escrito.
      </p>
      <h3 className="text-xl font-serif font-bold text-brand-brown pt-2" data-id="element-99">
        4. Limitación de Responsabilidad
      </h3>
      <p data-id="element-100">
        No nos hacemos responsables de los resultados individuales obtenidos al
        seguir las recomendaciones de la guía. Los resultados pueden variar
        según cada persona.
      </p>
      <h3 className="text-xl font-serif font-bold text-brand-brown pt-2" data-id="element-101">
        5. Política de Reembolso
      </h3>
      <p data-id="element-102">
        Debido a la naturaleza digital del producto, todas las ventas son
        finales. Si tiene algún problema con su compra, estaremos encantados de
        ayudarle.
      </p>
    </>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-brand-brown text-brand-beige py-12 px-6 text-center" data-id="element-103">
        <div className="max-w-4xl mx-auto" data-id="element-104">
          <p className="text-sm opacity-70 mb-6 leading-relaxed" data-id="element-105">
            Descargo de responsabilidad: La información contenida en esta guía
            es con fines educativos y no sustituye el consejo médico
            profesional. Consulte siempre con su médico antes de comenzar
            cualquier nuevo protocolo de salud o ejercicios, especialmente si
            tiene condiciones médicas preexistentes.
          </p>
          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-106">
            <button onClick={() => setActiveModal('privacy')} className="text-sm opacity-70 hover:opacity-100 underline underline-offset-4 transition-opacity" data-id="element-107">
              Política de Privacidad
            </button>
            <span className="text-sm opacity-40" data-id="element-108">·</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm opacity-70 hover:opacity-100 underline underline-offset-4 transition-opacity" data-id="element-109">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-sm opacity-50" data-id="element-110">
            &copy; {new Date().getFullYear()} Rodillas Sin Dolor. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>

      {activeModal === 'privacy' && <Modal title="Política de Privacidad" onClose={() => setActiveModal(null)} data-id="element-111">
          <PrivacyContent data-id="element-112" />
        </Modal>}
      {activeModal === 'terms' && <Modal title="Términos y Condiciones" onClose={() => setActiveModal(null)} data-id="element-113">
          <TermsContent data-id="element-114" />
        </Modal>}
    </>;
}